import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IonProgressBar } from '@ionic/angular/standalone';
import { NavigationStateService } from 'src/app/shared/services/navigation/navigation-state.service';

/** A thin moving bar along the top while the next page is loading its data. */
@Component({
  selector: 'app-navigation-progress',
  standalone: true,
  imports: [IonProgressBar],
  template: `
    @if (navigationState.slow()) {
      <ion-progress-bar
        type="indeterminate"
        class="fixed top-0 right-0 left-0 z-[99998] h-1"
        data-testid="navigation-progress"
      ></ion-progress-bar>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationProgressComponent {
  protected readonly navigationState = inject(NavigationStateService);
}
